import React from 'react'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '@/shared/components/ui/dialog'
import { Button } from '@/shared/components/ui/button'

const DialogBox = ({
    trigger,
    title,
    description,
    onSubmit,
    submitBtnLabel = 'Submit',
    body,
    open,
    setOpen,
}: {
    trigger: React.ReactNode
    title: string
    description: string
    onSubmit: () => void
    submitBtnLabel?: string
    body: React.ReactNode
    open: boolean
    setOpen: (value: boolean) => void
}) => {
    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger>{trigger}</DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>{description}</DialogDescription>
                </DialogHeader>
                {body}
                <Button onClick={onSubmit}>{submitBtnLabel}</Button>
            </DialogContent>
        </Dialog>
    )
}

export default DialogBox
